<template>
  <div class="h-screen" style="height: 100%; z-index: 100">
    <video-background
      src="https://space-cdn-dokomaps.fra1.cdn.digitaloceanspaces.com/nft20/dali_background.mp4"
      muted="false"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
      "
    />
    <div
      style="
        z-index: 110;
        position: absolute;
        left: 50px;
        right: 50px;
        top: 50px;
      "
    >
      <div v-if="step == 0">
        <div class="text-5xl bg-blue-600 text-white">Be a part of fART</div>
        <div class="mt-1 text-l bg-blue-600 text-white">
          During the 1200s a new format for painting—the altarpiece—appeared in
          Italian churches. Previously, fresco and mosaic decoration were
          predominant, and Western artists did not often paint on wooden panels.
          Soon, however, the gilded and painted panels, often combined into
          elaborately framed multipanel assemblages, assumed a primary place.
        </div>
        <div v-if="!isConnected">
          <ConnectWallet />
        </div>
        <div v-if="isConnected">
          <button
            v-on:click="step = 1"
            class="border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-3 mt-6 text-2xl"
          >
            I uderstand art
          </button>
        </div>
      </div>

      <div v-if="step == 1">
        <div class="text-5xl bg-blue-600 text-white">But art...</div>
        <div class="mt-1 text-l bg-blue-600 text-white">
          Philosophically, art is interesting for its exploration of the
          eternally vexing issue of just what is it exactly that distinguishes a
          piece of canvas and oil paint. Plato and Aristotle are held to a
          representational theory of art, in which artworks imitate real
          physical objects. But they differ radically on the matter of whether
          it was possible to gain either intellectual or practical knowledge
          about real-world things from their art-world representations....
        </div>

        <button
          v-on:click="step = 2"
          class="border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-3 mt-6 text-2xl"
        >
          Just give me the airdrop
        </button>
      </div>

      <div v-if="step == 2">
        <div class="text-5xl bg-blue-600 text-white">Art is sharing...</div>
        <div class="mt-1 text-l bg-blue-600 text-white">
          There is something that can happen when we push our work out into the
          world of humanity. Whatever it is that happens is distinct from what
          happens when we destroy a work, throw it away, lose it, or hide it.
          Somehow we are free of and freed from the work when we push it out
          away from ourselves and into culture. We have now new room, renewed
          capacity and potential, and a new direct liveliness to make our next
          work.
        </div>
        <div class="mt-1 text-l bg-blue-600 text-white">
          At this point, we may be free of the necessity to share; we may even
          shun sharing because it disturbs our making. Then, when again we have
          filled to capacity our self and our making place with work, we must
          push it all away from us out into the culture and get back our
          emptiness-full-of-potential.
        </div>
        <div class="mt-1 text-xl bg-blue-600 text-white">
          Obviously, those who didn't share the art, won't get fart...
        </div>
        <button
          v-on:click="step = 3"
          class="border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-3 mt-6 text-2xl"
        >
          Add twitter share HERE
        </button>
        =======
        <div class="mt-1 text-l bg-blue-600 text-white">
          There is something that can happen when we push our work out into the
          world of humanity. Whatever it is that happens is distinct from what
          happens when we destroy a work, throw it away, lose it, or hide it.
          Somehow we are free of and freed from the work when we push it out
          away from ourselves and into culture. We have now new room, renewed
          capacity and potential, and a new direct liveliness to make our next
          work.
        </div>
        <div class="mt-1 text-l bg-blue-600 text-white">
          At this point, we may be free of the necessity to share; we may even
          shun sharing because it disturbs our making. Then, when again we have
          filled to capacity our self and our making place with work, we must
          push it all away from us out into the culture and get back our
          emptiness-full-of-potential.
        </div>
        <div class="mt-1 text-xl bg-blue-600 text-white">
          Obviously, those who didn't share the art, won't get fart...
        </div>
        <a
          :href="twitterURL"
          target="_blank"
          class="border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-3 mt-6 text-2xl"
          >Share on Tweeter</a
        >
        <button
          v-on:click="step = 3"
          class="border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-3 mt-6 text-2xl"
        >
          Just give me the airdrop
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectWallet from "@/components/ConnectWallet.vue";

export default {
  components: { ConnectWallet },
  data: function () {
    return {
      step: 0,
    };
  },
  mounted: function () {},
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
    twitterURL: function () {
      return (
        "https://twitter.com/intent/tweet?text=I%20love%20fart%20and%20I%27m%20joining%20the%20adventure,%20play%20with%20me%20at%20https://verynifty.io%20%23fart%20@NiftyMuseum%20" +
        this.$store.state.account
      );
    },
  },
  watch: {
    isConnected: async function () {},
  },
};
</script>

<style scoped>
</style>
